module.exports = __webpack_public_path__ + "img/thq_slide_1.eb478ae0.jpg";